import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../../commonComponents/translate';
import CurrencyProp from '../../../profile/propTypes/currencyProp';
import {
  formatNumbers,
  newFormatPrice,
} from '../../../../services/utilityFunctions';

function MonthlySummary(props) {
  const { t, data, showModal } = props;

  const {
    VALeft,
    VARight,
    groupVA,
    globalCommissions,
    commissions,
    remainingVA,
    currencyInfo,
  } = data;

  return (
    <div className="monthly-summaries">
      <div className="summary-header">
        <div className="career-section-title">
          {t('report.arcova.monthlySummary')}
        </div>
        <button
          type="button"
          onClick={() => showModal()}
          className="see-details"
        >
          {t('report.arcova.seeDetails')}
        </button>
      </div>
      <div className="row">
        <div className="col-6 col-sm-2 summary">
          <div className="card">
            <span className="monthly-summary-label orange">
              {t('report.arcova.VALeft')}
            </span>
            <span className="value">{formatNumbers(VALeft, false, true)}</span>
          </div>
        </div>
        <div className="col-6 col-sm-2 summary">
          <div className="card">
            <span className="monthly-summary-label cyan">
              {t('report.arcova.VARight')}
            </span>
            <span className="value">{formatNumbers(VARight, false, true)}</span>
          </div>
        </div>
        <div className="col-6 col-sm-2 summary">
          <div className="card">
            <span className="monthly-summary-label blue">
              {t('report.arcova.groupVA')}
            </span>
            <span className="value">{formatNumbers(groupVA, false, true)}</span>
          </div>
        </div>
        <div className="col-6 col-sm-2 summary">
          <div className="card">
            <span className="monthly-summary-label yellow">
              {t('report.arcova.globalCommissions')}
            </span>
            <span className="value">
              {newFormatPrice(globalCommissions, true, currencyInfo.code)}
            </span>
          </div>
        </div>
        <div className="col-6 col-sm-2 summary">
          <div className="card">
            <span className="monthly-summary-label green">
              {t('report.arcova.commissions')}
            </span>
            <span className="value">
              {newFormatPrice(commissions, true, currencyInfo.code)}
            </span>
          </div>
        </div>
        <div className="col-6 col-sm-2 summary">
          <div className="card">
            <span className="monthly-summary-label purple">
              {t('report.arcova.remainingVA')}
            </span>
            <span className="value">
              {formatNumbers(remainingVA, false, true)}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

MonthlySummary.propTypes = {
  t: PropTypes.func.isRequired,
  data: PropTypes.shape({
    VALeft: PropTypes.number,
    VARight: PropTypes.number,
    groupVA: PropTypes.number,
    globalCommissions: PropTypes.number,
    commissions: PropTypes.number,
    remainingVA: PropTypes.number,
    currencyInfo: PropTypes.shape(CurrencyProp.propType),
  }).isRequired,
  showModal: PropTypes.func.isRequired,
};

export default translate(MonthlySummary);
